export const ReferenceType = {
  FREE_FORMAT: 'FreeFormat',
  ARRAY: 'Array',
}
